import { Breadcrumbs, Link, Typography, useTheme } from "@mui/material";
import useIsMobile from "helpers/hooks/useIsMobile";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import usePageData from "helpers/context/Page/usePageData";
import { Link as RouterLink } from "react-router-dom";
import { useMemo } from "react";
import { isNullOrWhiteSpace } from "helpers/objects";

const ActionBarBreadcrumbs: React.FC = () => {

    const pageInfo = usePageData();
    const theme = useTheme();
    const isMobile = useIsMobile();

    const lastBreadcrumb: string = useMemo(() => {
        if (pageInfo.title.length > 0) {
            return pageInfo.title[pageInfo.title.length - 1];
        }
        return "";
    }, [pageInfo]);

    if (isMobile && !isNullOrWhiteSpace(lastBreadcrumb)) {
        return <Typography
            key={lastBreadcrumb}
            color={theme.palette.primary.contrastText}
            variant="h6"
        >
            {lastBreadcrumb}
        </Typography>
    }
    
    return <Breadcrumbs
        aria-label="breadcrumb"
        color={theme.palette.primary.contrastText}
        separator={<NavigateNextIcon fontSize="small" />}
    >
        {pageInfo.title.map((c, i) => (
            i < pageInfo.path.length ?
            <Link component={RouterLink} to={pageInfo.path[i]}
                key={c}
                color={theme.palette.primary.contrastText}
                variant="h6"
            >
                {c}
            </Link>
            :
            <Typography
                key={c}
                color={theme.palette.primary.contrastText}
                variant="h6"
            >
                {c}
            </Typography>
        ))}
    </Breadcrumbs>
}

export default ActionBarBreadcrumbs;